<template>
  <div>
    <check-base-layout
      :pagetitle="pagetitle"
      :check-info-data="{}"
    >
      <template>
        <check-module :title="`维修信息`">
          <template>
            <el-row>
              <el-col :span="8">
                <div class="pb20">售后类型：{{}}</div>
              </el-col>
              <el-col :span="8">
                <div class="pb20">发起时间：{{}}</div>
              </el-col>
              <el-col :span="8">
                <div class="pb20">客户商合同编号：{{}}</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div class="pb20">公司名称：<span class="theme-blue">{{}}</span></div>
              </el-col>
              <el-col :span="8">
                <div class="pb20">维修状态：{{}}</div>
              </el-col>
              <el-col :span="8">
                <div class="pb20">产品价值：{{}}</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div class="">故障说明：{{}}</div>
              </el-col>
              <el-col :span="8">
                <div class="" style="display: flex">
                  <span>附件：</span>
                  <div style="flex:1;">
                    <ul class="theme-blue fileList_ul">
                      <li>fujian.png</li>
                      <li>fujian.png</li>
                      <li>fujian.png</li>
                      <li>fujian.png</li>
                    </ul>
                  </div>
                </div>
              </el-col>
            </el-row>
          </template>
        </check-module>
        <check-module :title="`维修方案`">
          <template>
            <el-row>
              <el-col :span="8">
                <div class="pb20">方案类型：{{}}</div>
              </el-col>
              <el-col :span="8">
                <div class="pb20">维修费用：{{}}</div>
              </el-col>
              <el-col :span="8">
                <div class="pb20">预计维修耗时：{{}}</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div class="">方案说明：{{}}</div>
              </el-col>
              <el-col :span="8">
                <div class="">维修检测报告：<el-button type="primary">下载</el-button></div>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
              <el-col :span="8">
                <div class="pb20">客户承担：{{}}</div>
              </el-col>
              <el-col :span="8">
                <div class="pb20">公司承担：{{}}</div>
              </el-col>
              <el-col :span="8">
                <div class="pb20">提成结算：{{}}</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div class="pb20">合同结算：{{}}</div>
              </el-col>
              <el-col :span="8">
                <div class="pb20">费用小计：{{}}</div>
              </el-col>
            </el-row>
          </template>
        </check-module>
        <check-module :title="`维修清单`">
          <el-table
            :data="tableData"
            :header-cell-style="tableHeader"
            border
            v-loading="loadingtable"
            element-loading-text="拼命加载中请稍后..."
            element-loading-spinner="el-icon-loading"
          >
            <el-table-column prop="brandName" label="品牌"></el-table-column>
            <el-table-column prop="brandName" label="系列"></el-table-column>
            <el-table-column prop="brandName" label="产品名称"></el-table-column>
            <el-table-column prop="brandName" label="型号">
              <template slot-scope="scope">
                <span class="theme-blue">{{scope.row.brandName}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="brandName" label="订货号"></el-table-column>
            <el-table-column prop="brandName" label="单位"></el-table-column>
            <el-table-column prop="brandName" label="单品报价"></el-table-column>
            <el-table-column prop="brandName" label="实际供货单价"></el-table-column>
            <el-table-column prop="brandName" label="总报价"></el-table-column>
            <el-table-column prop="brandName" label="实际供货总价"></el-table-column>
            <el-table-column prop="brandName" label="毛利率"></el-table-column>
            <el-table-column prop="brandName" label="产品序列号">
              <template slot-scope="scope">
                <el-button type="text" @click="seeProNumber(scope.row)">查看</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="brandName" label="维修数量"></el-table-column>
          </el-table>
        </check-module>
      </template>
      <template v-slot:checkFooter>
        <slot name="footer">
          <check-module :title="`审批信息`">
            <check-info-module></check-info-module>
          </check-module>
        </slot>
      </template>
    </check-base-layout>
    <check-drawer
      :visible.sync="checkVisible"
    >

    </check-drawer>
  </div>
</template>

<script>
import poMixins from '@/mixin/poMixins'
import checkDrawer from '@/components/checkLayout/module/checkDrawer'
// import infoTable from '@/components/module/infoTable'
export default {
  name: 'maintaincostCheck',
  mixins: [poMixins],
  components: {
    checkDrawer
  },
  props: {
    pagetitle: {
      type: String,
      default: '维修费用结算审批'
    }
  },
  data () {
    return {
      loadingtable: false,
      tableData: [{}],
      checkVisible: false
    }
  },
  methods: {
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    seeProNumber (row) {
      this.checkVisible = true
    }
  }
}
</script>

<style scoped lang="less">
.fileList_ul{
  display: flex;
  margin:0;
  padding:0;
  flex-wrap: wrap;
  list-style: none;
  li{
    width:50%;
    margin-bottom: 8px;
    white-space: nowrap;
    overflow:hidden;
    text-overflow: ellipsis;
  }
}
</style>
